import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { FolderDb } from '../redux/folderDbSlice';

const useCurrentFolderDb = () : FolderDb | undefined => {
  const folderDb = useSelector((state: RootState) => state.folderDb);
  if (folderDb.currentFolderId) {
    const folderId = folderDb.currentFolderId;
    const folderValue = folderDb.folders[folderId];
    return folderValue;
  } else {
    return undefined;
  }
}

export default useCurrentFolderDb;
